/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class Extracurriculars extends SubCatAccordion implements IsubCatAccordion
    {
        typeCbs = [
            { type: "Student Newspaper", isChecked: false },
            { type: "Radio Station", isChecked: false },
            { type: "Television Station", isChecked: false },
            { type: "Fraternities", isChecked: false },
            { type: "Sororities", isChecked: false },
            { type: "Club/Intramural Sports", isChecked: false },
            { type: "ROTC", isChecked: false },
            { type: "Music (Performing Arts)", isChecked: false }
        ];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
}